import { render } from "./Loader.vue?vue&type=template&id=136be4dd&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=136be4dd&scoped=true&lang=css"

import exportComponent from "/var/www/dashboard.epsasport-dev.apps.lu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136be4dd"]])

export default __exports__